$(document).ready(function(){
	if(!document.querySelector('.announcements-list')) return false;

	var announceList = {
		el: document.getElementById('search_for_announcement'),
		checkSubmit: function(){
			$(announceList.el).find('.submit').off().on({
				click: function(e){
					e.preventDefault();
					if($(announceList.el).checkValidation()) {
						adobeTrackEvent('announcement-submit', {search_keyword : $(announceList.el).find('.search-area .search-input input[type=text]').val(), search_type : "support:announcement", page_event : {onsite_search : true}});
						announceList.el.submit();
					}
				}
			});
		},
		addEvent: function(){
			$(document.querySelector('.announcements-list .pagination')).on({
				click: function(e){
					var cur = e.currentTarget,
						pageNum = cur.value;
					announceList.el.pageNum.value = pageNum;
					announceList.el.submit();
				}
			}, 'button, a');
		}
	};
	announceList.checkSubmit();
	announceList.addEvent();
});